import { css } from '@emotion/react';
import { useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import {
	Avatar,
	Menu,
	MenuButton,
	MenuItem,
	MenuPopover,
} from '@adflow/frontend/ui-common';
import { su } from '@adflow/frontend/ui-theme';
import { useAuth, useMutationLogout } from '@adflow/frontend/util-auth';

import { UserProfileModal } from './UserProfileModal';

const styles = {
	avatarButton: css({
		cursor: 'pointer',
		// Give the user a big area to tap/click even if the button's icon is small.
		width: '3rem',
		marginRight: '0.25rem',
		height: '100%',

		// Center content horizontally
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',

		// Offset to line up avatar with other icons
		justifyContent: 'flex-end',
		paddingBottom: '0.5rem',
	}),
};

export function UserMenu() {
	const { t } = useTranslation(['common', 'login']);

	const { user } = useAuth();

	const { mutate: logout } = useMutationLogout();

	const [userProfileModalOpen, toggleProfileModal] = useReducer(
		(state) => !state,
		false
	);

	return (
		<>
			<Menu
				trigger={
					<MenuButton
						css={styles.avatarButton}
						data-testid="profile-icon-button"
					>
						<Avatar name={user.name} size="small" />
						<div css={su.text2xs}>{user?.name?.split(' ')?.[0]}</div>
					</MenuButton>
				}
			>
				<MenuPopover data-testid="profile-icon-menu">
					<MenuItem onSelect={toggleProfileModal} data-testid="profile">
						{t('sections.profile')}
					</MenuItem>
					<MenuItem onSelect={logout} data-testid="logout">
						{t('login:action Log out')}
					</MenuItem>
				</MenuPopover>
			</Menu>
			<UserProfileModal
				show={userProfileModalOpen}
				onCancel={toggleProfileModal}
				onSave={toggleProfileModal}
			/>
		</>
	);
}
